import { settings } from '../assets/resources/settings'

export const send = async (data, isPreview) => {
	const backendUrl = `${settings.backendApi}/email${isPreview ? '/test' : ''}`;
	return await fetch(backendUrl,
		{
			method: 'POST',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(data)
		}).then(res => {
			if (res.ok) {
				return null
			}

			throw (new Error("Something went wrong"))

		})
}